import { RenderAmountProps } from "./renderAmount";
import "./renderVarniAmount.css";

export function RenderVarniAmount(props: RenderAmountProps) {

    const clicked = (event: any): void => {
        props.onClicked(props.value);
    }

    const renderText = () => {
        if (!props.text)
            return (<></>);

        return (<div className="helpText">{props.text}</div>)
    }

    return (<div className="varni-amount">
        <div className={"color-yb bubble center-text " + (props.selected ? "color-yb-selected" : "")} onClick={clicked}>
            {renderText()}
            <div className="amountText"> ${props.value}</div>
        </div>
    </div>)
}